import React from 'react';
import { Link } from 'react-router-dom';
import { PLACEHOLDER_COURSE_IMAGE } from '../../constants';
import { formatCoursePrice } from '../../utils/priceUtils';
import './RelatedCourseCard.css';

export default function RelatedCourseCard({ course }) {
  return (
    <Link to={`/course/${course.id}`} className="related-course-card">
      <div className="related-course-card-image-wrap">
        <img src={course.thumbnail || PLACEHOLDER_COURSE_IMAGE} alt="" className="related-course-card-image" onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_COURSE_IMAGE; }} />
      </div>
      <div className="related-course-card-body">
        <h3 className="related-course-card-title">{course.title}</h3>
        <p className="related-course-card-instructor">{course.instructor}</p>
        {course.rating != null && (
          <p className="related-course-card-rating">
            <span className="related-course-card-rating-value">{course.rating}</span>
            {course.reviewCount != null && (
              <span className="related-course-card-review-count"> ({course.reviewCount.toLocaleString()})</span>
            )}
          </p>
        )}
        <p className="related-course-card-price">{formatCoursePrice('Free')}</p>
      </div>
    </Link>
  );
}
